/** i18n helpers for Agent inbox list (sort), not sentiment analysis */

export const SORT_OPTION_KEYS = [
  { value: 'date_created', key: 'assistant.sort.dateCreated', direction: 'desc' },
  { value: 'date_updated', key: 'assistant.sort.dateUpdated', direction: 'desc' },
  { value: 'message_count', key: 'assistant.sort.messageCount', direction: 'desc' },
  { value: 'message_count_asc', key: 'assistant.sort.messageCountAsc', direction: 'asc' }
];
